import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SystemStatusBanner } from "@/components/SystemStatusBanner";

interface Props {
  children: ReactNode;
  className?: string;
}

/**
 * MobileShell — centers content in a phone-like frame on desktop
 * while filling the viewport on mobile.
 */
export const MobileShell = ({ children, className }: Props) => (
  <div className="min-h-screen w-full bg-secondary/40 flex justify-center">
    <div
      className={cn(
        "w-full max-w-md min-h-screen bg-background flex flex-col relative shadow-card",
        className,
      )}
    >
      <SystemStatusBanner />
      {children}
    </div>
  </div>
);
